import React from "react";
import { FlagSVG } from "../../assets/svgs";
import { flagLaterText, unFlagText } from "../../utils/constants";

const FlagButton = ({ onClick, isFlagged, disabled }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="set-color-flag buttonQuiz orange-buttonQuiz"
      disabled={disabled}
    >
      {!isFlagged ? (
        <span className="flag-answer-buttonQuiz">
          <FlagSVG />
        </span>
      ) : null}
      {isFlagged ? unFlagText : flagLaterText}
    </button>
  );
};
export default FlagButton;
